export default __webpack_public_path__ + "static/media/logokikaholland.bbc9c6cd.png";